import {ReactElement} from 'react';
import styled from "styled-components";
import {mediaQueries} from '@theme/lib';
import StyledPill from '@components/Pill';

export const StyledPillItem = styled.li`
  margin-bottom: 0.75rem;
`;

export const StyledPillList = styled.ul`
  flex-basis: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 0 1rem;
  list-style: none;

  ${mediaQueries.md} {
    justify-content: flex-end;
  }
`;

export const StyledPillWrapper = styled.div`
  grid-column: 1 / span 5;
  margin-bottom: 0.75rem;

  ${mediaQueries.md} {
    flex-flow: row wrap;
    grid-column: 2 / span 3;
  }

  ${mediaQueries.lg} {
    margin-bottom: 2.5rem;
    grid-column: 2 / span 8;
  }
`;

export type Props = {
  items: string[];
  onClick: (item: string) => void;
};


export default function Pills({
  items,
  onClick
}: Props): ReactElement<any> {

  return (
    <StyledPillWrapper>
      <StyledPillList>
        {items.map((item, index) =>
          <StyledPillItem key={index}>
            <StyledPill title={item} onClick={onClick} />
          </StyledPillItem>
        )}
      </StyledPillList>
    </StyledPillWrapper>
  );
}
